import styled from "styled-components";

export const Muted = styled.span`
  color: ${props => props.theme.colors.muted};
`;
